<!-- 员工资料 -->
<template>
  <div class="user">
    <div class="" v-loading="loading">
      <div class="s_wrapper">
        <el-select v-model="storeId" placeholder="所属门店" @change="onSearch" clearable>
          <el-option v-for="item in options" :key="item.storeId" :label="item.storeName" :value="item.storeId">
          </el-option>
        </el-select>
        <el-input class="s_input" v-model="employeeCode" placeholder="搜索员工编号" suffix-icon="el-icon-search" @change="onSearch" clearable></el-input>
        <el-input class="s_input" v-model="employeeName" placeholder="搜索员工名称" suffix-icon="el-icon-search" @change="onSearch" clearable></el-input>
        <el-input class="s_input" v-model="positionName" placeholder="搜索岗位" suffix-icon="el-icon-search" @change="onSearch" clearable></el-input>
        <el-button type="primary" @click="handleImport">导入</el-button>
        <el-button type="primary" @click="handleDownload">模板下载</el-button>
        <el-button type="primary" @click="handleAdd">新增</el-button>
      </div>

      <div class="g_table">
        <el-table :data="tableData" style="width: 100%" max-height="540">
          <el-table-column label="序号" show-overflow-tooltip width="80">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column prop="picUrl" label="查看头像" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-image v-show="false" :preview-src-list="srcList" ref="previewImg"></el-image>
              <div style="color: #069BBC;cursor: pointer;" @click="handleCommandLogo(scope.row.picUrl)">查看头像</div>
            </template>
          </el-table-column>
          <el-table-column prop="employeeCode" label="员工编号" show-overflow-tooltip></el-table-column>
          <el-table-column prop="employeeName" label="员工名称" show-overflow-tooltip></el-table-column>
          <el-table-column label="性别">
            <template slot-scope="scope">
              <span>{{ comSex(scope.row.sex) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="age" label="年龄" show-overflow-tooltip></el-table-column>
          <el-table-column prop="idNum" label="身份证" show-overflow-tooltip min-width="140"></el-table-column>
          <el-table-column prop="contactTel" label="手机号码" show-overflow-tooltip min-width="100"></el-table-column>
          <el-table-column prop="nativePlace" label="籍贯" show-overflow-tooltip></el-table-column>
          <el-table-column prop="departmentName" label="部门" show-overflow-tooltip min-width="100"></el-table-column>
          <el-table-column prop="positionName" label="职位" show-overflow-tooltip min-width="100"></el-table-column>
          <el-table-column prop="enrollmentDate" label="入职时间" show-overflow-tooltip min-width="100"></el-table-column>
          <el-table-column prop="enrollmentTime" label="在职天数" show-overflow-tooltip min-width="100"></el-table-column>
          <el-table-column prop="storeName" label="所属门店" show-overflow-tooltip min-width="100"></el-table-column>
          <el-table-column label="操作" header-align="center" align="center" width="160" fixed="right">
            <template slot-scope="scope">
              <el-button class="btn" type="" size="" plain @click="handleEdit(scope.$index, scope.row)">修改</el-button>
              <el-button class="btn" type="danger" size="" plain @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>

    <el-dialog :title="isAdd ? '新增' : '修改'" :visible.sync="dialogVisible" width="60%" :before-close="onCancel">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="ruleForm">
        <el-row type="flex" justify="center">
          <el-col :span="10">
            <el-form-item label="姓名" prop="employeeName">
              <el-input v-model="ruleForm.employeeName" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="idNum">
              <el-input v-model="ruleForm.idNum" placeholder="请输入身份证号"></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="contactTel">
              <el-input v-model="ruleForm.contactTel" placeholder="请输入手机号码"></el-input>
            </el-form-item>
            <el-form-item label="部门" prop="departmentId">
              <el-cascader v-model="ruleForm.departmentId" :show-all-levels="false" :options="options1" :props="{checkStrictly:false, emitPath:false ,expandTrigger: 'hover' ,value:'departmentId',label:'departmentName', children:'childDepartmentInfoVos'}" placeholder="请选择" clearable></el-cascader>
              <!-- <el-select v-model="ruleForm.departmentId" collapse-tags placeholder="请选择" clearable>
                <el-option v-for="item in options" :key="item.departmentId" :label="item.storeName" :value="item.departmentId"></el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label="入职时间" prop="enrollmentDate">
              <el-date-picker type="date" placeholder="选择日期" v-model="ruleForm.enrollmentDate" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="员工头像" prop="picUrl">
              <div class="pic-row">
                <div class="pic">
                  <el-upload class="logo_uploader" accept=".png,.jpeg,.jpg" name="multipartFile" :action="apiBaseUrl" :show-file-list="false" :on-success="handleSuccess" :before-upload="beforeUploads" :on-remove="handleRemoveLogo">
                    <img v-if="ruleForm.picUrl" :src="ruleForm.picUrl" class="logoimg" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <!-- <i v-if="ruleForm.picUrl" class="delpic delpic1 el-icon-error" @click="handleRemoveLogo"></i> -->
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="性别" prop="sex">
              <el-select v-model="ruleForm.sex" placeholder="请选择">
                <el-option label="女" value="0"></el-option>
                <el-option label="男" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="出生日期" prop="birthDate">
              <el-date-picker type="date" placeholder="选择日期" v-model="ruleForm.birthDate" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="籍贯" prop="nativePlace">
              <el-input v-model="ruleForm.nativePlace" placeholder="请输入籍贯"></el-input>
            </el-form-item>
            <el-form-item label="职位" prop="positionId">
              <el-select v-model="ruleForm.positionId" collapse-tags placeholder="请选择">
                <el-option v-for="item in options2" :key="item.positionId" :label="item.positionName" :value="item.positionId" clearable></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属门店" prop="storeId">
              <el-select v-model="ruleForm.storeId" collapse-tags placeholder="请选择" cl>
                <el-option v-for="item in options" :key="item.storeId" :label="item.storeName" :value="item.storeId" clearable></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" :loading="submitLoding">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 导入 -->
    <el-dialog title="导入" :visible.sync="importShow" :before-close="onImportCancel">
      <el-form label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="上传附件" required>
              <el-upload :action="apiBaseUrl" :headers="apiHeaders" :file-list="importFiles" accept=".xlsx,.xls" :on-change="beforeUpload" :auto-upload="false" :limit="1" :on-exceed="handleExceed" :on-remove="handleRemove">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip" style="color: red">提示：只能上传"xlsx"、"xls"文件，且不超过5MB</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="onImportCancel">取 消</el-button>
        <el-button type="primary" @click="submitFormImport('importRuleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
function createInitRuleForm() {
  return {
    employeeName: "",
    sex: "",
    birthDate: "",
    idNum: "",
    contactTel: "",
    nativePlace: "",
    enrollmentDate: "",
    storeId: "",
    departmentId: "",
    positionId: "",
    picUrl: ""
  }
}
export default {
  data() {
    // 正则表达式验证身份证的格式
    var validateIdCard = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("身份证不能为空"))
      }
      const idCardRegex = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}([0-9]|X)$/
      if (!idCardRegex.test(value)) {
        callback(new Error("身份证格式不正确"))
      } else {
        callback()
      }
    }
    var checkTel = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("联系电话不能为空"))
      }
      const telRegex = /^(?:(?:\+|00)86)?1\d{10}$/
      if (!telRegex.test(value)) {
        callback(new Error("联系电话格式不正确"))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      submitLoding: false,
      positionName: "",
      employeeName: "",
      employeeCode: "",
      storeId: '',
      options: [],
      options1: [],
      options2: [],
      tableData: [],
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
      dialogVisible: false,
      isAdd: true,
      ruleForm: createInitRuleForm(),
      rules: {
        employeeName: [{ required: true, message: "请输入姓名", trigger: ["blur", "change"] }],
        sex: [{ required: true, message: "请选择性别", trigger: ["blur", "change"] }],
        birthDate: [{ required: true, message: "请选择日期", trigger: ["blur", "change"] }],
        enrollmentDate: [{ required: true, message: "请选择日期", trigger: ["blur", "change"] }],
        storeId: [{ required: true, message: "请选择门店", trigger: ["blur", "change"] }],
        positionId: [{ required: true, message: "请选择岗位", trigger: ["blur", "change"] }],
        departmentId: [{ required: true, message: "请选择部门", trigger: ["blur", "change"] }],
        nativePlace: [{ required: true, message: "请输入籍贯", trigger: ["blur", "change"] }],
        contactTel: [{ required: true, validator: checkTel, trigger: ["blur", "change"] }],
        idNum: [{ required: true, validator: validateIdCard, trigger: ["blur", "change"] }],
        picUrl: [{ required: false, message: "请上传员工头像", trigger: "change" }],
      },
      roleList: [],
      apiBaseUrl: this.$axios.defaults.baseURL + this.$api.uploadFile,
      apiHeaders: {
        token: this.$store.state.token,
      },

      importShow: false,
      importFiles: [], //文件列表
      srcList: [],


    }
  },
  created() {
    this.getSysUserList()
    this.getSysRoleList()
    this.positionInfoSelect()
    this.getdePartmentList()
  },
  computed: {
    comSex() {
      return function (sex) {
        return sex == 0 ? "女" : sex == 1 ? "男" : "未知"
      }
    },
  },
  methods: {
    // 上传成功
    handleSuccess(res) {
      const { code, result } = res
      if (code == 100) {
        this.$set(this.ruleForm, 'picUrl', result.fileUrl)
      } else {
        this.$message({ showClose: true, message: res.desc, type: "error" })
      }

    },
    // 上传前检查
    beforeUploads(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/jpg" || file.type === "image/png"
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isJPG) {
        this.$message.error("图文只支持jpg、png、jpeg，请调整格式再上传!")
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!")
      }
      return isJPG && isLt5M
    },
    // 删除
    handleRemoveLogo() {
      // this.ruleForm.picUrl = ""
      this.$set(this.ruleForm, 'picUrl', '')

    },
    // 查看图片
    handleCommandLogo(imageUrl) {

      if (imageUrl) {
        this.srcList = [imageUrl];
        this.$refs.previewImg.showViewer = true;
      } else {
        this.$message.error("未上传员工头像!");
      }
    },
    // 导入弹窗关闭
    onImportCancel() {
      this.importShow = false
      this.importFiles = []
    },
    handleImport() {
      this.importShow = true
    },
    handleDownload() {
      this.$axios.post(this.$api.employeeDownload).then(res => {
        this.$message.success('下载成功')
        window.open(res.data.result)
      }).catch(() => {
        this.$message.error('下载失败')
      })
    },
    beforeUpload(file) {
      const suffixArr = ["xlsx", "xls"]
      const maxSize = 1024 * 1024 * 5
      if (!suffixArr.includes(file.name.split(".").pop())) {
        this.$message.error(`只能上传"xlsx"、"xls"文件`)
        this.importFiles = []
        return false
      }
      if (file.size > maxSize) {
        this.$message.error("附件不能超过5M")
        this.importFiles = []
        return false
      }
      this.importFiles.push(file.raw)
    },
    handleExceed() {
      this.$message.warning(`只能上传一个文件！`)
    },
    handleRemove() {
      this.importFiles = []
    },
    // 导入表单校验
    submitFormImport() {
      if (!this.importFiles || this.importFiles.length == 0) {
        return this.$message.warning("请先上传文件")
      }
      // console.log(this.importFiles,'importFiles');

      let parmas = new FormData()
      parmas.append("file", this.importFiles[0])
      this.$axios.post(this.$api.importEmployee, parmas).then(res => {
        if (res.code == 100) {
          this.$message.success("导入成功!")
          this.onImportCancel()
          this.getSysUserList()
        }
      }).catch(err => {
        this.$message.error(err.desc)
      })
    },
    // 用户列表
    getSysUserList() {
      this.loading = true
      this.$axios
        .get(this.$api.employeeSelect, {
          params: {
            employeeName: this.employeeName,//员工名称
            positionName: this.positionName,//岗位
            employeeCode: this.employeeCode,//编号
            storeId: this.storeId,//门店id
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list
            this.totalItemsCount = res.result.totalCount

          }
          this.loading = false
        })
        .catch(err => {
          this.$message.error(err.desc)
          this.loading = false
        })
    },
    // 门店列表
    getSysRoleList() {
      this.$axios.get(this.$api.selectStoreInfoList, {
        params: {
          page: 1,
          pageSize: 999,
        },
      }).then(res => {
        this.options = res.result.list
      })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    // 部门列表
    getdePartmentList() {
      this.$axios.get(this.$api.departmentInfoSelect, {
        params: {
          page: 1,
          pageSize: 999,
        },
      }).then(res => {
        this.options1 = res.result
      })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    // 职位列表
    positionInfoSelect() {
      this.$axios.get(this.$api.positionInfoSelect, {
        params: {
          page: 1,
          pageSize: 999,
        },
      }).then(res => {
        this.options2 = res.result.list
      })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    // 搜索
    onSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getSysUserList()
    },
    // 新增（对话框）
    handleAdd() {
      this.isAdd = true
      this.dialogVisible = true
    },
    // 修改（对话框）
    handleEdit(index, row) {
      // console.log(row);

      this.isAdd = false
      this.ruleForm = Object.assign({}, row)
      this.dialogVisible = true
      // this.$axios.post(`${this.$api.getSysUserById}/${row.userId}`)
      //   .then(res => {
      //     if (res.code == 100) {
      //       this.ruleForm = res.result
      //       this.dialogVisible = true
      //     } else {
      //       this.dialogVisible = false
      //     }
      //   })
      //   .catch(() => {
      //     this.dialogVisible = false
      //   })
    },
    // 删除
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除该员工, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        this.$axios.post(`${this.$api.employeeDelete}/${row.employeeId}`).then(res => {
          if (res.code == 100) {
            this.$message.success(res.desc)
          }
          this.getSysUserList()
        }).catch(err => {
          this.$message.error(err.desc)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      })
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getSysUserList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getSysUserList()
    },
    // 关闭对话框
    onCancel() {
      this.dialogVisible = false
      this.resetForm()
    },
    // 提交表单
    submitForm(formName) {
      this.submitLoding = true
      let params = Object.assign({}, this.ruleForm)
      let api = ""
      let methods = ""
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.isAdd) {
            api = this.$api.insert
            methods = "post"
          } else {
            api = this.$api.employeeUpdate
            methods = "post"
          }
          this.$axios[methods](api, params)
            .then(res => {
              this.$message.success(res.desc)
              this.getSysUserList()
              this.submitLoding = false
              this.dialogVisible = false
              this.resetForm()
              // console.log(res);

            }).catch(() => {
              this.submitLoding = false
              // this.$message.error(desc)
              // console.log(err);

            })
        } else {
          this.submitLoding = false
          this.$message.error("提交失败")
          return false
        }
      })
    },
    // 重置校验
    resetForm() {
      this.ruleForm = createInitRuleForm()
      this.$refs.ruleForm.resetFields()
    },
  },
}
</script>

<style scoped lang="scss">
.user {
  .disabled_user_account {
    width: 255px;
    color: #c0c4cc;
    padding: 0 15px;
    border-radius: 10px;
    background-color: #f5f7fa;
    box-sizing: border-box;
    cursor: not-allowed;
  }
}
.pic-row {
  display: flex;

  .pic {
    margin-right: 15px;

    .logo_uploader {
      ::v-deep .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }

      ::v-deep .el-upload:hover {
        border-color: #069bbc;
      }

      .avatar-uploader-icon {
        font-size: 28px;
        color: #069bbc;
        width: 100px;
        height: 100px;
        line-height: 100px;
        text-align: center;
      }

      .logoimg {
        width: 100px;
        height: 100px;
        display: block;
        object-fit: cover;
      }
    }
  }
}
</style>
